module.exports = __webpack_public_path__ + "static/assets/5f9d6653aab20d42cfe26f9e4ab480cd.svg";